import { Form } from 'antd';
import { SeedTicket } from 'constants/interface';
import { buildRegularProductDisplay, buildSimpleQuantityDisplay } from 'helpers/order';
import React, { useState } from 'react';
import { useDispatch } from 'hooks/store';
import {
  DatePicker,
  Input,
  InputNumber,
  Modal,
} from 'UI';
import { confirmSeedTicketAction } from 'state/slices/productionItem';
import { createAlertNotification } from 'infra/notification';
import { AlertNotificationType, setNotificationAction } from 'state/slices/notification';
import { unwrapResult } from '@reduxjs/toolkit';
import { Dayjs } from 'dayjs';
import { formatStringDate } from 'helpers/utils';

import {
  InlineButton,
  MainContainer,
  FormContainer,
  ItemInfoContainer,
  ItemInfoRow,
  ItemInfoLabel,
  ItemInfoValue,
  BaseFormItem,
  FormItemRow,
} from './style';

interface ConfirmTicketModalProps {
  item?: SeedTicket
  isVisible: boolean
  onCancel: () => void
  // onSuccess: () => void
}

interface ConfirmTicketFormData {
  purchaseDate: Dayjs
  provider: string
  purchaseQuantity: string
  estimatedReceivingDate: Dayjs
}

const TicketDetailsModal = ({
  item,
  isVisible,
  onCancel,
  // onSuccess,
}: ConfirmTicketModalProps): JSX.Element => (
  <Modal
    visible={isVisible}
    title={`Solicitação Nº ${item?.seq || ''}`}
    destroyOnClose
    onCancel={onCancel}
    afterClose={onCancel}
    zIndex={90}
    footer={[
      <InlineButton
        key="cancel"
        onClick={onCancel}
        type="ghost"
      >
        Fechar
      </InlineButton>,
      // <InlineButton
      //   key="submit"
      //   onClick={confirmSeedTicket}
      //   disabled={isLoading}
      //   loading={isLoading}
      // >
      //   Salvar
      // </InlineButton>,
    ]}
  >
    <MainContainer>
      {/* Request Info */}
      <ItemInfoContainer>
        <ItemInfoRow>
          <ItemInfoLabel>Cliente:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.productionItem.orderItem.order.client.name || ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Cultivar:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? buildRegularProductDisplay(item.productionItem, {
              quantity: false,
              tray: false,
            }) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Quantidade prevista:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? buildSimpleQuantityDisplay(item.requestQuantity) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Unidade:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? item.productionItem.orderItem.order.organization.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Data da solicitação:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? formatStringDate(item.createdAt) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Solicitante:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item ? item.createdBy.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
      </ItemInfoContainer>

      {/* Confirmation Info */}
      <ItemInfoContainer>
        <ItemInfoRow>
          <ItemInfoLabel>Data da compra:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.purchaseDate ? formatStringDate(item.purchaseDate) : ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Fornecedor:</ItemInfoLabel>
          <ItemInfoValue>{`${item?.provider || ''}`}</ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Quantidade solicitada:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.purchaseQuantity ? buildSimpleQuantityDisplay(item.purchaseQuantity) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Previsão de entrega:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.estimatedReceivingDate ? formatStringDate(item.estimatedReceivingDate) : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
        <ItemInfoRow>
          <ItemInfoLabel>Comprador:</ItemInfoLabel>
          <ItemInfoValue>
            {`${item?.purchasedBy ? item.purchasedBy.name : ''}`}
          </ItemInfoValue>
        </ItemInfoRow>
      </ItemInfoContainer>
    </MainContainer>
  </Modal>
);

export default TicketDetailsModal;
